<template>
  <div class="btn-group">
    <button
      class="btn btn-white"
      :disabled="!hasPrevious"
      type="button"
      @click="handlePreviousButton"
    >
      <i class="fa fa-chevron-left"></i>
    </button>

    <button
      class="btn btn-white"
      :key="page"
      :class="{'active': currentPage === page}"
      v-for="page in pages"
      @click="handlePageSelection(page)"
    >{{ page }}</button>

    <button class="btn btn-white" type="button" :disabled="!hasNext" @click="handleNextButton">
      <i class="fa fa-chevron-right"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Paginator',
  props: {
    pages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasNext() {
      return this.currentPage < this.pages;
    },

    hasPrevious() {
      return this.currentPage > 1;
    },
  },
  methods: {
    handleNextButton() {
      this.$emit('goToNextPage');
    },
    handlePreviousButton() {
      this.$emit('goToPreviousPage');
    },
    handlePageSelection(page) {
      this.$emit('goToPage', page);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Paginator.vue?7492ec21